import { CrmAccessTokenPayloadDto } from '@sparling/financial-common'
import { ApplicationStore } from '../states'

export const updateAccessTokenData: (state: ApplicationStore, payload: CrmAccessTokenPayloadDto) => ApplicationStore = (
  state,
  payload,
) => {
  return {
    ...state,
    accessTokenData: payload,
  }
}

export const removeAccessTokenData: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.accessTokenData
  return {
    ...newState,
  }
}
